import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers-pro';
import { Moment } from 'moment';
import colors from '../../../../common/colors';
import QuickFilters from '../QuickFilters';
import type { DateRange, QuickFilter } from '../../types';

interface DesktopViewProps {
  selectedFilter: string | null;
  handleQuickSelect: (key: string) => void;
  filters: QuickFilter[];
  dateRange: DateRange;
  handleStartDateChange: (newValue: Moment | null) => void;
  handleEndDateChange: (newValue: Moment | null) => void;
  handleCancel: (e: React.MouseEvent<HTMLElement>) => void;
  handleApply: () => void;
  isApplyDisabled: boolean;
}

const DesktopView: React.FC<DesktopViewProps> = ({
  selectedFilter,
  handleQuickSelect,
  filters,
  dateRange,
  handleStartDateChange,
  handleEndDateChange,
  handleCancel,
  handleApply,
  isApplyDisabled,
}) => {
  return (
    <Box
      display="flex"
      sx={{
        mt: 1,
        position: 'absolute',
        zIndex: 1300,
        top: '100%',
        left: 0,
        backgroundColor: colors.white,
        p: '16px',
        boxShadow: 10,
        borderRadius: 1,
      }}
    >
      <Box sx={{ pt: 2, backgroundColor: colors.white }}>
        <QuickFilters
          selectedFilter={selectedFilter}
          onQuickSelect={handleQuickSelect}
          filters={filters}
        />
      </Box>

      <Box data-calendar-type="start">
        <Typography
          variant="body2"
          bgcolor="white"
          sx={{
            textAlign: 'left',
            paddingLeft: 3,
            paddingTop: 1,
            borderRight: `1px solid ${colors.neutral_400}`,
          }}
        >
          Start date
        </Typography>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={dateRange[0]}
          onChange={handleStartDateChange}
          views={['year', 'month', 'day']}
          sx={{
            borderRight: `1px solid ${colors.neutral_400}`,
          }}
        />
      </Box>

      <Box data-calendar-type="end">
        <Typography
          bgcolor={colors.white}
          variant="body2"
          sx={{
            textAlign: 'left',
            paddingLeft: 3,
            paddingTop: 1,
          }}
        >
          End date
        </Typography>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={dateRange[1]}
          onChange={handleEndDateChange}
          views={['year', 'month', 'day']}
          shouldDisableDate={(date) => {
            return dateRange[0] ? date.isBefore(dateRange[0], 'day') : false;
          }}
        />

        <Box
          width="100%"
          sx={{
            display: 'flex',
            justifyContent: 'end',
            gap: 1,
          }}
        >
          <Button
            onClick={handleCancel}
            variant="text"
            sx={{
              textTransform: 'none',
              color: colors.grey_300,
              borderColor: colors.grey_300,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApply}
            disabled={isApplyDisabled}
            variant="contained"
            sx={{
              textTransform: 'none',
              backgroundColor: colors.grey_300,
              '&:hover': {
                backgroundColor: colors.grey_300,
              },
            }}
          >
            Apply
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DesktopView;
